// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2634 ? "2c796e83" : chunkId) + "." + {"2634":"96198bd6dc49cc18","2741":"c8b8f30a84a38d21","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};